import { Component, OnInit } from '@angular/core';
import { DataserviceService } from '../dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzTableQueryParams } from 'ng-zorro-antd/table';

@Component({
  selector: 'app-duplicate-queue',
  templateUrl: './duplicate-queue.component.html',
  styleUrls: ['./duplicate-queue.component.css']
})

export class DuplicateQueueComponent implements OnInit {
  duplicateOrders: any[] = [];
  isModalVisible = false;
  selectedOrder: any = null;
  duplicateOrderNumber = '';
  loading: boolean = false;

  constructor(
    private dataService: DataserviceService,
    private message: NzMessageService
  ) {}

  ngOnInit() {
    this.loadDuplicates();
  }

  loadDuplicates() {
    this.loading = true;
    this.dataService.getData('work-order/pending-duplicates')
      .subscribe({
        next: (data: any) => {
          this.duplicateOrders = data;
          this.loading = false;
        },
        error: (error) => {
          this.message.error('Failed to load duplicate orders');
          console.error(error);
          this.loading = false;
        }
      });
  }

  showResolveModal(order: any) {
    this.selectedOrder = order;
    this.duplicateOrderNumber = '';
    this.isModalVisible = true;
  }

  handleOk() {
    if (!this.duplicateOrderNumber.trim()) {
      this.message.warning('Please enter a duplicate order number');
      return;
    }

    let obj = {
      orderId: this.selectedOrder.id,
      duplicateOrderNumber: this.duplicateOrderNumber
    }

    this.dataService.postData(obj, `work-order/resolve-duplicate`)
      .subscribe({
        next: () => {
          this.message.success('Duplicate order resolved');
          this.loadDuplicates();
          this.isModalVisible = false;
        },
        error: (error) => {
          this.message.error('Failed to resolve duplicate order');
          console.error(error);
        }
      });
  }

  handleCancel() {
    this.isModalVisible = false;
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    const { sort } = params;
    const currentSort = sort.find((s: any) => s.value !== null);
  
    if (currentSort) {
      const { key, value } = currentSort;
      this.duplicateOrders = [...this.duplicateOrders].sort((a, b) => {
        let valA = a[key];
        let valB = b[key];
  
        if (key === 'first_name') {
          valA = `${a.first_name} ${a.last_name}`;
          valB = `${b.first_name} ${b.last_name}`;
        }
  
        if (key === 'sale_date') {
          valA = new Date(a.sale_date).getTime(); 
          valB = new Date(b.sale_date).getTime();
        }
  
        if (typeof valA === 'string' && typeof valB === 'string') {
          return value === 'ascend' ? valA.localeCompare(valB) : valB.localeCompare(valA);
        }
  
        return value === 'ascend' ? valA - valB : valB - valA;
      });
    }
  }
}